import FundClimateProjectsFintechPng from '@public/images/fintech-and-banking/fund-climate-projects-fintech.png'
import { FC } from 'react'

import { ColumnWrapOrder } from '@/components/TwoColumnLayout'
import TwoColumnLayoutWithCustomImageRatio from '@/components/TwoColumnLayoutWithCustomImageRatio'

const EnableYourUsersFintech: FC = () => (
    <TwoColumnLayoutWithCustomImageRatio
        columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
        imagePaddingBottom={'108.64%'}
        imageAlt={'transaction offset notifications'}
        image={FundClimateProjectsFintechPng}
        title={`Vetted, high-quality carbon projects`}
        description={
            <>
                Advance your customers’ sustainability goals by embedding impactful climate projects
                into your customer experience. Our experts rigorously vet climate projects against a
                six-point criteria to deliver measurable impact and peace of mind.
            </>
        }
    />
)

export default EnableYourUsersFintech
